import { render } from "./LaborersAttendanceConfig.vue?vue&type=template&id=a8b031ce&scoped=true"
import script from "./LaborersAttendanceConfig.vue?vue&type=script&lang=js"
export * from "./LaborersAttendanceConfig.vue?vue&type=script&lang=js"

import "./LaborersAttendanceConfig.vue?vue&type=style&index=0&id=a8b031ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b031ce"],['__file',"src/views/h5/luqiao/laborers/attendance/config/LaborersAttendanceConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8b031ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8b031ce', __exports__)) {
    api.reload('a8b031ce', __exports__)
  }
  
  module.hot.accept("./LaborersAttendanceConfig.vue?vue&type=template&id=a8b031ce&scoped=true", () => {
    api.rerender('a8b031ce', render)
  })

}


export default __exports__